export class Role {
  id: number;
  code: string;
  label: string;
}
